import { LayoutStyle } from '../LayoutStyle'

export default (style: string | undefined | null): LayoutStyle =>
    style === 'dark' ? 'dark' : 'light'
